import { create } from "zustand";

export const usePayoutStatusModal = create((set) => ({
  payoutStatus: null,
  setPayoutStatus: (val) => set({ payoutStatus: val }),
}));
